<template>
        <TransactionInput :action="action" :transaction-i-d="transactionID" :draft-i-d="draftID"> </TransactionInput>
</template>


<script>
import TransactionInput from "../../components/TransactionInput"
export default {
	name: "CloneTransactionView",
	components: {TransactionInput},
	data(){
		return{
			action:"clone" ,
			transactionID:location.pathname?.split("/")?.reverse()?.[1],
			draftID:null,
		}
	}
}
</script>
